import PropTypes from 'prop-types';

export const fieldShape = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
};
